import * as SearchCriteriasStyle
  from '../../styles/actualites/sciencespo/search-criterias.module.scss';
import PropTypes from 'prop-types';
import { cloneDeep, concat, filter, flatten, isEqual, uniqWith } from 'lodash';

import CategoriesContainer from '../shared/CategoriesContainer';
import Encadre from '../shared/ckeditor/Encadre';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SearchCriterias = React.memo(function SearchCriterias ({
  categories,
  getSelectedCategories,
}) {
  const [subcategories, setSubcategories] = React.useState([]);
  const [copiedCategories, setCopiedCategories] = React.useState(
    cloneDeep(categories)
  );
  const { t } = useTranslation();

  const getCategories = React.useCallback((newCategories) => {
    setCopiedCategories(newCategories);
    setSubcategories(
      uniqWith(
        flatten(
          newCategories
            ?.filter((category) => category.clicked)
            ?.map((elem) => elem.subcategories)
        ),
        isEqual
      )
    );
  }, []);

  const getSubcategories = React.useCallback((newSubcategories) => {
    setSubcategories(newSubcategories);
  }, []);

  React.useEffect(() => {
    getSelectedCategories(
      concat(
        filter(copiedCategories, (elem) => elem.clicked),
        filter(subcategories, (elem) => elem.clicked)
      )
    );
  }, [subcategories, copiedCategories, getSelectedCategories]);

  React.useEffect(() => {
    setCopiedCategories(cloneDeep(categories));
  }, [categories]);

  return (
    <>
      <Encadre color="secondary">
        <div style={{ marginBottom: 10 }}>
          <div style={{ marginBottom: 10 }}>
            <p className={SearchCriteriasStyle.title}>
              {t('news.guide.page.filter')}
            </p>
          </div>
          {copiedCategories?.length > 0 && (
            <CategoriesContainer
              elements={copiedCategories}
              getCategories={getCategories}
              isUnique
            />
          )}
        </div>
      </Encadre>
      {subcategories?.length > 0 && (
        <Encadre>
          <div style={{ marginBottom: 10 }}>
            <CategoriesContainer
              elements={subcategories}
              getCategories={getSubcategories}
            />
          </div>
        </Encadre>
      )}
    </>
  );
});

SearchCriterias.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      clicked: PropTypes.bool,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          label: PropTypes.string,
          clicked: PropTypes.bool,
        })
      ),
    })
  ).isRequired,
  getSelectedCategories: PropTypes.func.isRequired,
};

export default SearchCriterias;
